export default {
  configuration: {
    zh: '配置',
    en: 'Configuration',
  },
  connection: {
    zh: '连接',
    en: 'Connection',
  },
  schema: {
    zh: '模式',
    en: 'Schema',
  },
  fileManagement: {
    zh: '文件管理',
    en: 'Files Management',
  },
  resource: {
    zh: '资源',
    en: 'Resources',
  },
  confKeyResource: {
    zh: '配置组资源',
    en: 'Configuration Key Resources',
  },
  sourceConfKeys: {
    zh: '源配置组',
    en: 'Source configuration keys',
  },
  sinkTemplates: {
    zh: '传输与存储模板',
    en: 'Sink templates',
  },
  confKey: {
    zh: '配置组',
    en: 'Configuration key',
  },
  viewConfKey: {
    zh: '查看配置组',
    en: 'View configuration key',
  },
  addConfKey: {
    zh: '添加配置组',
    en: 'Add configuration key',
  },
  editConfKey: {
    zh: '编辑配置组',
    en: 'Edit configuration key',
  },
  addSourceConfKey: {
    zh: '添加源配置组',
    en: 'Add source configuration key',
  },
  addSinkTemplate: {
    zh: '添加传输与存储模板',
    en: 'Add sink template',
  },
  editSourceConfKey: {
    zh: '编辑源配置组',
    en: 'Edit source configuration key',
  },
  editSinkTemplate: {
    zh: '编辑传输与存储模板',
    en: 'Edit sink template',
  },
  connectionSelector: {
    zh: '连接选择器',
    en: 'Connection Selector',
  },
}
